// Legacy promotions may store HTML in a field now used for Quill Delta data.
// Convert before binding it to an object-format editor so a status-only save
// does not perpetuate an unreadable frontend description or T&C.
export function promotionEditorValue(quill: any, value: any): any {
  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed?.ops)) return parsed;
      if (Array.isArray(parsed)) return { ops: parsed };
    } catch { /* Existing HTML is converted by Quill's clipboard. */ }
    return quill.clipboard.convert({ html: value });
  }
  if (Array.isArray(value)) return { ops: value };
  return value && Array.isArray(value.ops) ? value : { ops: [] };
}
